module.exports = __webpack_public_path__ + "img/1521500485.959d4f33.jpg";